import queryString from 'query-string';
import React, { useEffect, useRef, useState } from 'react';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import Loader from 'react-loader-spinner';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  authenticateUser,
  checkEmail,
  getOtpViaCall,
  loginSuccess,
  loginWithEmail,
  otpVerification,
  verifyTheOtp
} from '../../../Store/actions/login.action';
import packageJson from '../../../../package.json';
import { changeRoute } from '../../../Store/actions/settings.action';
import { saveUtm } from '../../../Store/actions/shareActions';
import { getVaultList } from '../../../Store/actions/vault.action';
import { CLICK_RESEND_OTP } from '../../../TrackerFolder/constants/ActionType';
import { postAppOneSignalId } from '../../../capacitor/capacitorOneSignal';
import {
  getLocalStorage,
  getSessionStorage,
  isEligibleForSpeciality,
  log,
  removeSessionStorage,
  setLocalStorage
} from '../../../common/common';
import isdCodeJson from '../../../common/data/isdcode.json';
import { useReadOTP } from '../../../components/customHooks/useReadOTP.ts';
import { IoIosArrowDown } from '../../../components/icons';
import Timer from '../../../pages/spq/components/Timer';
import './css/shareLogin.scss';

const ALLOWED_REGION = 'IN';
const ShareLogin = (props) => {
  const mobileRef = useRef('');
  const isdRef = useRef('+91');
  const userRegionState = useSelector((state) => state.share.UserRegion);
  const autoAuthLocation = useRef(null);
  const [mobileNo, SetMobileNo] = useState('');
  const [err_msg, set_err_msg] = useState('');
  const [loginType, setLoginType] = useState(2);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isd, setIsd] = useState('+91');
  const [otp, setOtp] = useState('');
  const [showButton, setShowButton] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { id, election_id } = useParams();
  const [userRegion, setUsersRegion] = useState('');

  // console.log('election id', election_id);
  console.log('paramsparamsparams', props.paramData);

  useReadOTP((otp_params) => {
    if (otp_params) {
      setOtp(otp_params);

      verifyOtp(mobileRef.current, isdRef.current, otp_params);
    }
  }, true);

  const params = useParams();
  const { search } = useLocation();
  const navigateToAssociatedPath = () => {
    // alert('navigateToAssociatedPath===<<<<<<<>>>>>>==='+ props.redirectType);

    if (props?.to?.pathname == '/TrainingContent') {
      navigate({ ...props.to, pathname: '/TrainingCover' }, { state: { from_login: true } });
    } else {
      console.log('navigateToAssociatedPath else===<<<<<<<>>>>>>===', props.to, props.redirectType);
      navigate(props.to, { state: { from_login: true } });
    }
  };
  const existingEmail = queryString.parse(search);
  const isJSON = (text) => {
    if (
      /^[\],:{}\s]*$/.test(
        text
          .replace(/\\["\\\/bfnrtu]/g, '@')
          .replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']')
          .replace(/(?:^|:|,)(?:\s*\[)+/g, '')
      )
    ) {
      return true;
    } else {
      return false;
    }
  };
  const navigateToDetailsPage = (content_type, content_id) => {
    removeSessionStorage('autoauth_location');
    if (content_type == 'session') {
      navigate(`/SessionDetails?id=${content_id}`, { state: { from_login: true } });
    } else if (content_type == 'medwiki') {
      navigate(`/MedwikiDetails?id=${content_id}`, { state: { from_login: true } });
    } else if (content_type == 'archived_video') {
      navigate(`/ClinicalVideoDetails?id=${content_id}`, { state: { from_login: true } });
    } else if (content_type == 'survey') {
      navigate(`/SPQdetails?id=${content_id}`, { state: { from_login: true } });
    } else if (content_type == 'gr') {
      navigate(`/GrandRoundDetails?id=${content_id}`, { state: { from_login: true } });
    } else if (content_type == 'epub') {
      navigate(`/EbookDetails?id=${content_id}`, { state: { from_login: true } });
    } else {
      navigate(`/Dashboard`, { state: { from_login: true } });
    }
  };

  useEffect(() => {
    if (userRegionState && userRegionState != ALLOWED_REGION && loginType != 1) {
      GetEmailFunc();
    }
  }, [userRegionState]);

  useEffect(() => {
    if (getSessionStorage('autoauth_location', '')) {
      let temp = getSessionStorage('autoauth_location', '')?.split(',');
      console.log('temp', temp);
      if (temp?.length > 1) {
        autoAuthLocation.current = { type: temp[0], id: temp[1] };
      }
    }
    if (search) {
      setLoginType(1);
      setEmail(existingEmail.email);
      set_err_msg('You have already registered with this email address. Please login to proceed.');
    } else {
      setEmail('');
    }

    return () => {
      // user_id = null;
      SetMobileNo('');
    };
  }, []);

  useEffect(() => {
    // console.log('Param Data', props.paramData);
    getParams();
  }, [props.paramData]);
  useEffect(() => {
    mobileRef.current = mobileNo;
    isdRef.current = isd;
    console.log('===>>>REF', mobileRef.current, isdRef.current);
  }, [mobileNo, isd]);
  // const onHandleTag = (tag) => {
  //   console.log("Tagging");
  //   OneSignalReact.sendTag('tech',tag).then(() => {
  //     console.log("Tagged")
  //   })

  // }

  // let { from } = location.state || { from: { pathname: `/${props.redirectType}/${id}` } };

  const loginEmail = (e) => {
    e.preventDefault();
    if (typeof props.setBackdrop == 'function') {
      props.setBackdrop(true);
    }
    let formData = new FormData();
    formData.append('email', email);

    log('Proceed Login');
    if (email == '') {
      if (typeof props.setBackdrop == 'function') {
        props.setBackdrop(false);
      }
      set_err_msg('Please Enter Your Email');
    } else {
      let regexEmail =
        /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;
      if (!email.trim().match(regexEmail)) {
        if (typeof props.setBackdrop == 'function') {
          props.setBackdrop(false);
        }
        set_err_msg('Please Enter a Valid Email');
      } else {
        if (password == '') {
          if (typeof props.setBackdrop == 'function') {
            props.setBackdrop(false);
          }
          set_err_msg('Please Enter Your Password');
        } else {
          let emailFormData = new FormData();
          emailFormData.append('email', email.trim());
          dispatch(
            checkEmail(emailFormData, (res) => {
              if (res.status_code == 200) {
                let formData = new FormData();
                formData.append('email', email.trim());
                formData.append('password', password);
                getLocalStorage('utm_source', '') &&
                  formData.append('utm_source', getLocalStorage('utm_source', ''));
                dispatch(
                  loginWithEmail(formData, (res) => {
                    if (res != 'error') {
                      log('res', res);
                      if (res.status_code == 203) {
                        if (typeof props.setBackdrop == 'function') {
                          props.setBackdrop(false);
                        }
                        set_err_msg(res.message);
                      } else if (res.status_code == 200) {
                        if (res.data.status == 3) {
                          setLocalStorage('accessToken', res.data.token);
                          setLocalStorage('refreshToken', res.data.refresh_token);
                          dispatch(
                            authenticateUser(res.data.refresh_token, (resp) => {
                              if (resp != 'error') {
                                if (resp.status_code == 200) {
                                  postAppOneSignalId(res.data.token, resp.data.user_master_id);
                                  dispatch(loginSuccess());

                                  dispatch(
                                    getVaultList((res) => {
                                      if (res != 'error') {
                                        // log("vaultCount", res.data.length);
                                        if (res.data) {
                                          setLocalStorage('vaultCount', res.data?.length ?? 0);
                                        } else {
                                          setLocalStorage('vaultCount', 0);
                                        }
                                      }
                                    })
                                  );
                                  console.log('RedirectType', props.redirectType);
                                  console.log(props.to);
                                  setLocalStorage('user', resp.data);
                                }
                              }
                            })
                          );
                        } else {
                          set_err_msg('This Email is not Registered');
                        }
                      } else {
                      }
                    } else {
                      if (typeof props.setBackdrop == 'function') {
                        props.setBackdrop(false);
                      }
                      set_err_msg('Something Went Wrong');
                    }
                  })
                );
              } else {
                navigate(`/registration/${email}`);
              }
            })
          );
        }
      }
    }
    console.log('exit===<<<<<<<', err_msg);
  };

  const GetMobileFunc = () => {
    set_err_msg('');
    setLoginType(2);
  };

  const GetEmailFunc = () => {
    set_err_msg('');
    setLoginType(1);
  };

  const GetOtpFunc = (e) => {
    if (e) {
      e.preventDefault();
    }

    if (mobileNo == '') {
      set_err_msg('Please Enter Your Mobile No');
    } else {
      let regexMob = /^\d{10}$/;
      let alpanum = /^[a-z0-9]+$/i;
      if (!mobileNo.trim().match(regexMob) && mobileNo.trim().match(alpanum)) {
        set_err_msg('Please Enter Mobile No in Correct Format');
      } else {
        // setLoginType(3);
        set_err_msg('');
        setIsLoading(true);
        let formData = new FormData();
        formData.append('isdCode', isd);
        formData.append('phone_no', mobileNo.trim());
        getLocalStorage('utm_source', '') &&
          formData.append('utm_source', getLocalStorage('utm_source', ''));
        dispatch(
          otpVerification(formData, (res) => {
            setIsLoading(false);
            if (res != 'error') {
              if (res.status_code == 203) {
                set_err_msg(res.message);
              } else if (res.status_code == 200) {
                log('otp API response', res);
                setLoginType(3);
              } else {
              }
            } else {
              set_err_msg('Something Went Wrong');
            }
          })
        );
      }
    }
  };

  const getParams = () => {
    if (props.paramData) {
      if (props.paramData.type == 'phone' || props.paramData.type == 'mobile') {
        SetMobileNo(props.paramData.data);
        if (mobileNo) {
          GetOtpFunc();
        }
      } else {
        console.log('Hello In Email');
        let formData = new FormData();
        formData.append('email', props?.paramData.data);

        dispatch(
          checkEmail(formData, (res) => {
            if (res.status_code == 200) {
              setEmail(props.paramData.data);
              setLoginType(1);
              dispatch(saveUtm(props.paramData.utm));
            } else {
              navigate(`/registration/${props.paramData.data}`);
            }
          })
        );
      }
    }
  };

  const verifyOtp = (mobileNo = '', isd = '+91', otp = '') => {
    // props?.tracker?.on(CLICK_LOGIN_BUTTON, onLoginButtonClick(props.pageName, mobileNo, ''));
    if (typeof props.setBackdrop == 'function') {
      props.setBackdrop(true);
    }
    if (otp == '') {
      set_err_msg('Please Enter the Otp');
      if (typeof props.setBackdrop == 'function') {
        props.setBackdrop(false);
      }
    } else {
      set_err_msg('');
      let formData = new FormData();
      formData.append('isdCode', isd);
      formData.append('phone_no', mobileNo.trim());
      formData.append('otp', otp.trim());
      dispatch(
        verifyTheOtp(formData, (res) => {
          log('verified response', res);
          if (res != 'error') {
            if (res.status_code == 203) {
              if (typeof props.setBackdrop == 'function') {
                props.setBackdrop(false);
              }
              set_err_msg(res.message);
              setShowButton(true);
            } else if (res.status_code == 200) {
              if (res.data.status == 2) {
                navigate(`/registration?mobile=${mobileNo}`, {
                  state: {
                    errMsg: 'You Are not registered with us.Please Register '
                  }
                });
              }

              if (res.data.status == 3) {
                setLocalStorage('accessToken', res.data.token);
                setLocalStorage('refreshToken', res.data.refresh_token);
                dispatch(
                  authenticateUser(res.data.refresh_token, (resp) => {
                    if (resp != 'error') {
                      if (resp.status_code == 200) {
                        dispatch(loginSuccess());
                        dispatch(
                          getVaultList((res) => {
                            if (res != 'error') {
                              // log("vaultCount", res.data.length);
                              if (res.data) {
                                setLocalStorage('vaultCount', res.data?.length ?? 0);
                              } else {
                                setLocalStorage('vaultCount', 0);
                              }
                            }
                          })
                        );
                        setLocalStorage('user', resp.data);
                        postAppOneSignalId(res.data.token, resp.data.user_master_id);
                        /** speciality route check*/
                        if (isEligibleForSpeciality(resp.data)) {
                          console.log(
                            'isEligibleForSpeciality' + isEligibleForSpeciality(resp.data)
                          );
                          dispatch(changeRoute(true));
                        }
                        /** */
                        console.log('DOCTUBE_AUTOAUTH', autoAuthLocation.current);
                        // if (typeof props.setBackdrop == 'function') {
                        //   props.setBackdrop(false);
                        // }

                        // if (autoAuthLocation.current) {
                        //   navigateToDetailsPage(
                        //     autoAuthLocation.current.type,
                        //     autoAuthLocation.current.id
                        //   );
                        // } else {
                        //   if (props.redirectType == 'Dashboard') {
                        //     if (
                        //       resp?.data?.menu &&
                        //       isJSON(resp?.data?.menu) &&
                        //       JSON.parse(resp?.data?.menu)?.main == 'dnr'
                        //     ) {
                        //       setLocalStorage('main_menu', 'dnr');
                        //       // log('response', JSON.parse(resp?.data?.menu));

                        //       navigate('/DiscussRefer', {
                        //         state: { from_login: true }
                        //       });
                        //     } else {
                        //       navigateToAssociatedPath();
                        //     }
                        //     // navigate(props.to);
                        //   } else if (
                        //     props.redirectType == 'Telemed' ||
                        //     props.redirectType == 'userProfile'
                        //   ) {
                        //     navigate(`/${props.redirectType}`);
                        //   } else if (props.redirectType == 'Dnr') {
                        //     navigate('/DiscussRefer', {
                        //       state: {
                        //         fromShare: true,
                        //         from_login: true
                        //       }
                        //     });
                        //   } else {
                        //     navigate(`/${props.redirectType}?id=${id}`, {
                        //       state: { from_login: true }
                        //     });
                        //   }
                        // }
                      }
                    }
                  })
                );
              } else {
                if (typeof props.setBackdrop == 'function') {
                  props.setBackdrop(false);
                }
                setLoginType(1);
                set_err_msg(
                  'This Mobile is not Registered,Please Use Your Email Id or Register with Us'
                );
              }
            } else {
            }
          } else {
            if (typeof props.setBackdrop == 'function') {
              props.setBackdrop(false);
            }
            set_err_msg('Something Went Wrong');
          }
        })
      );
    }
  };

  const resendOtp = () => {
    trackActivityEvent(CLICK_RESEND_OTP, onResendOtpClick('Login'));
    setShowButton(false);
    setOtp('');
    let formData = new FormData();
    formData.append('isdCode', isd);
    formData.append('phone_no', mobileNo.trim());
    dispatch(
      otpVerification(formData, (res) => {
        if (res != 'error') {
          if (res.status_code == 203) {
            set_err_msg(res.message);
          } else if (res.status_code == 200) {
            log('otp API response', res);
            set_err_msg('Otp Sent Again');
          } else {
          }
        } else {
          set_err_msg('Something Went Wrong');
        }
      })
    );
  };

  const getCall = () => {
    setShowButton(false);
    let formData = new FormData();
    formData.append('isdCode', isd);
    formData.append('phone_no', mobileNo.trim());
    setOtp('');
    dispatch(
      getOtpViaCall(formData, (res) => {
        if (res != 'error') {
          if (res.status_code == 203) {
            set_err_msg(res.message);
          } else if (res.status_code == 200) {
            set_err_msg('Calling...');
          } else {
          }
        } else {
          set_err_msg('Something went Wrong');
        }
      })
    );
  };

  const focusInput = () => {
    setLoginType(2);
    set_err_msg('');
  };

  const handleChange = (e) => {
    SetMobileNo(e.target.value);
  };

  const redirectToRegistration = () => {
    if (props?.redirectType) {
      navigate(`/registration?redirect_type=${props?.redirectType}`, {
        state: {
          id: id || null,
          election_id: election_id || null
        }
      });
    } else {
      navigate(`/registration`, {
        state: {
          id: id || null,
          election_id: election_id || null
        }
      });
    }
  };

  const userDet = useSelector((state) => state.common.user_details);

  useEffect(() => {
    if (userDet !== '') {
      if (typeof props.setBackdrop == 'function') {
        props.setBackdrop(false);
      }

      if (autoAuthLocation.current) {
        navigateToDetailsPage(autoAuthLocation.current.type, autoAuthLocation.current.id);
      } else {
        if (props.redirectType == 'Dashboard') {
          if (userDet?.menu && isJSON(userDet?.menu) && JSON.parse(userDet?.menu)?.main == 'dnr') {
            setLocalStorage('main_menu', 'dnr');
            navigate('/DiscussRefer', { state: { from_login: true } });
          } else {
            console.log('exit===<<<<<<<||||>>>>>>===');

            navigateToAssociatedPath();
          }
          console.log('exit===<<<<<<<---->>>>>>===');
        } else if (props.redirectType == 'Telemed' || props.redirectType == 'UserProfile') {
          console.log('exit===<<<<<<<...>>>>>>===', props.redirectType);

          navigate(`/${props.redirectType}`);
        } else if (props.redirectType == 'Dnr') {
          console.log('exit===<<<<<<<>>>>>>===', props.redirectType);

          navigate('/DiscussRefer', {
            state: { fromShare: true, from_login: true }
          });
        } else if (props.redirectType == 'ElectionLanding') {
          console.log('exit===<<<<<<<>>>>>>===', props.redirectType);

          navigate(`/ElectionLanding?electionId=${election_id}`, {
            state: { from_login: true }
          });
        } else {
          console.log('exit===<<<<<<<>>>>>>===', id, props.redirectType);
          navigate(`/${props.redirectType}?id=${id}`, {
            state: { from_login: true }
          });
        }
      }
    }
  }, [userDet]);

  return (
    <>
      <div className="w-100 text-start shareLogin rounded pt-5 px-4 pb-5 shadow position-relative overflow-hidden d-flex justify-content-center align-items-center">
        <div className="rounded-circle bg-white bg-opacity-10 shareLoginCircle position-absolute"></div>
        <div className="w-100 shareLogin_In text-white position-relative z-1">
          <h2 className="fs-1 fw-bold text-white text-uppercase mb-3">Login Now</h2>
          <p className="fs-4 fw-normal">
            This platform is meant for Registered Medical Practioners only.
          </p>
          <div className="w-100 shareLoginForm mt-3">
            <form onSubmit={(e) => loginEmail(e)}>
              <div className="row mt-n3 m-0">
                {loginType == 1 && (
                  <>
                    <div className="col-12 shareLoginFormRow mt-4 position-relative p-0">
                      <FloatingLabel controlId="floatingInput" label="Email ID*">
                        <Form.Control
                          className={`fs-4 ${props.gtmTagVariable}_login_enter_email`}
                          type="text"
                          placeholder="Email ID*"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                          }}
                        />
                      </FloatingLabel>
                    </div>
                    <div className="col-12 shareLoginFormRow mt-4 position-relative p-0">
                      <FloatingLabel controlId="floatingInput1" label="Password*">
                        <Form.Control
                          className={`fs-4 ${props.gtmTagVariable}_login_enter_password`}
                          type="password"
                          placeholder="Password*"
                          value={password}
                          onChange={(e) => {
                            setPassword(e.target.value);
                          }}
                        />
                      </FloatingLabel>
                    </div>

                    <div className="col-12 shareLoginFormRow mt-4 position-relative p-0">
                      <button
                        className={`w-100 fs-16 fw-medium text-uppercase btn btn-secondary rounded-pill ${props.gtmTagVariable}_login_submit`}
                        type="submit"
                        aria-label="Submit"
                      >
                        Submit
                      </button>
                    </div>

                    {userRegionState == ALLOWED_REGION && (
                      <div className="col-12 shareLoginFormRow mt-4 position-relative p-0">
                        <button
                          className={`w-100 fs-16 fw-medium text-uppercase btn btn-primary rounded-pill ${props.gtmTagVariable}_login_with_number`}
                          onClick={GetMobileFunc}
                          aria-label="Login with mobile number"
                        >
                          Login With Mobile Number
                        </button>
                      </div>
                    )}
                    {err_msg && (
                      <div className="col-12 shareLoginFormRow text-danger text-center mt-3 position-relative p-0">
                        {err_msg}
                      </div>
                    )}
                  </>
                )}

                {loginType == 2 && (
                  <>
                    <div className="col-12 shareLoginFormRow shareLoginMobileNo rounded mt-3 position-relative p-0">
                      <div className="shareLoginIsd position-absolute top-0 start-0 h-100 bg-white text-dark border-1 border-end border-light">
                        <select
                          className="w-100 h-100 pe-5 ps-3 form-control border-0 text-center"
                          onChange={(e) => {
                            setIsd(e.target.value);
                          }}
                          defaultChecked="+91"
                        >
                          {isdCodeJson.map((item, index) => (
                            <option name={item.name} value={item.value}>
                              {item.value}
                            </option>
                          ))}
                        </select>
                        <IoIosArrowDown
                          customClass={'fs-16 position-absolute top-50 translate-middle-y'}
                        />
                      </div>
                      <FloatingLabel controlId="floatingInput" label="Enter Mobile No.*">
                        <Form.Control
                          className={`fs-4 border-0 ${props.gtmTagVariable}_login_enter_phNumber`}
                          type="text"
                          placeholder="Enter Mobile No."
                          pattern="[6789][0-9]{9}"
                          value={mobileNo}
                          onChange={(e) => handleChange(e)}
                          ref={props.focusRef}
                        />
                      </FloatingLabel>
                    </div>
                    <div className="col-12 shareLoginFormRow mt-4 position-relative p-0">
                      <button
                        className={`w-100 fs-16 fw-medium text-uppercase btn btn-secondary rounded-pill ${props.gtmTagVariable}_login_startHere`}
                        onClick={(e) => GetOtpFunc(e)}
                        aria-label="Start Here"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <Loader type="ThreeDots" color="#FFFFFF" height={25} width={30} />
                        ) : (
                          'Start Here'
                        )}
                      </button>
                    </div>
                    <div className="col-12 shareLoginFormRow mt-4 position-relative p-0">
                      <button
                        className={`w-100 fs-16 fw-medium text-uppercase btn btn-primary rounded-pill ${props.gtmTagVariable}_login_with_email`}
                        onClick={GetEmailFunc}
                        aria-label="Login with email"
                      >
                        Login with Email
                      </button>
                    </div>
                    {err_msg && (
                      <div className="col-12 shareLoginFormRow text-danger text-center mt-3 position-relative p-0">
                        {err_msg}
                      </div>
                    )}
                  </>
                )}
                {loginType == 3 && (
                  <>
                    <div className="col-12 shareLoginFormRow mt-4 position-relative p-0">
                      <FloatingLabel controlId="floatingInput" label="Enter OTP">
                        <Form.Control
                          className={`fs-4 ${props.gtmTagVariable}_login_enter_otp`}
                          type="text"
                          placeholder="Enter Mobile No."
                          autocomplete="one-time-code"
                          inputmode="numeric"
                          pattern="[0-9]*"
                          value={otp}
                          onChange={(e) => {
                            setOtp(e.target.value);
                          }}
                        />
                      </FloatingLabel>
                    </div>
                    <div className="col-12 shareLoginFormRow mt-4 position-relative p-0">
                      <button
                        className={`w-100 fs-16 fw-medium text-uppercase btn btn-secondary rounded-pill ${props.gtmTagVariable}_login_enter_submitOtp`}
                        onClick={(e) => {
                          e.preventDefault();
                          verifyOtp(mobileNo, isd, otp);
                        }}
                        aria-label="Submit OTP"
                      >
                        Submit Otp
                      </button>
                    </div>
                    <div className="col-12 shareLoginFormRow mt-4 position-relative p-0">
                      <button
                        className={`w-100 fs-16 fw-medium text-uppercase btn btn-primary rounded-pill ${props.gtmTagVariable}_login_edit_number`}
                        onClick={focusInput}
                        aria-label="Edit mobile number"
                      >
                        Edit Mobile Number
                      </button>
                    </div>
                    {err_msg && (
                      <div className="col-12 shareLoginFormRow text-danger text-center mt-3 position-relative p-0">
                        {err_msg}
                      </div>
                    )}
                  </>
                )}

                <a
                  className={`col-12 fs-4 fw-normal text-secondary shareLoginFormRow text-center cursorPointer mt-3 position-relative p-0 ${props.gtmTagVariable}_login_newUser_requestAccess`}
                  onClick={redirectToRegistration}
                >
                  New User? Request for access!
                </a>
                {loginType == 3 ? (
                  showButton ? (
                    <>
                      <a
                        className={`col-12 fs-4 fw-normal shareLoginFormRow cursorPointer mt-3 position-relative p-0 ${props.gtmTagVariable}_login_resend_otp`}
                        onClick={resendOtp}
                      >
                        Resend Otp
                      </a>
                      <a
                        className={`col-12 fs-4 fw-normal shareLoginFormRow cursorPointer mt-3 position-relative p-0 ${props.gtmTagVariable}_login_get_call_instead`}
                        onClick={() => {
                          getCall();
                        }}
                      >
                        Get Call Instead
                      </a>
                    </>
                  ) : (
                    <p>
                      <Timer
                        onDuration={(e) => {}}
                        seconds="30"
                        onEnded={() => {
                          setShowButton(true);
                        }}
                      />
                    </p>
                  )
                ) : null}

                <span className="col-12 fs-5 fw-normal shareLoginFormRow text-center mt-3 position-relative p-0">
                  CLIRNET v{packageJson.version}
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShareLogin;
